import {
  OdometerSource,
  RawVehicleTemplate,
} from "../typings/RawVehicleTemplate";
import { VehicleTemplateColumn } from "../typings/VehicleTemplateColumn";

// export type VehicleTemplate = {
//   id: string;
//   name: string;
//   description: string;
//   columns: VehicleTemplateColumn[];
//   ignitionValue: string;
//   tags: string[];
//   companies: string[];
//   owner: string;
//   isDefaultTemplate: boolean;
//   created: string;
//   modified: string;
// };

export class VehicleTemplate {
  private _columns: VehicleTemplateColumn[];

  public constructor(public readonly data: RawVehicleTemplate) {
    this._columns = Object.entries(data.all_columns).map(
      ([technicalName, column]) => ({
        technicalName,
        name: column.name,
        hover: column.hover,
        hasHover: column.has_hover,
        default: column.default,
        isDefault: data.default_columns.includes(technicalName),
        isDigital: !!data.is_digital?.includes(technicalName),
        unit: column?.unit,
        scale_factor: column?.scale_factor,
        digits_after_comma: column?.digits_after_comma,
        values_mapping_name: column?.values_mapping_name,
        type: column?.type,
      }),
    );
  }

  public get id(): string {
    return this.data._id;
  }

  public get name(): string {
    return this.data.name;
  }

  public get description(): string {
    return this.data.description;
  }

  public get columns(): VehicleTemplateColumn[] {
    return this._columns;
  }

  public get ignitionValue(): string {
    return this.data.ignition_value;
  }

  public get tags(): string[] {
    return this.data.tags;
  }

  public get companies(): string[] {
    return this.data.companies;
  }

  public get owner(): string {
    return this.data.owner;
  }

  public get isDefaultTemplate(): boolean {
    return this.data.is_default_template;
  }

  public get created(): string {
    return this.data.created;
  }

  public get modified(): string {
    return this.data.modified;
  }

  public get displayColumns(): string[] | null {
    return this.data.display_columns;
  }

  public get errorCodesMappingName(): string | null {
    return this.data.error_codes_mapping_name;
  }

  public get internalTariffId(): string | null {
    return this.data.internal_tariff_id;
  }

  public get odometerSource(): OdometerSource {
    return this.data.odometer_source ?? OdometerSource.Can;
  }
}

export type ChangableVehicleTemplate = Pick<
  VehicleTemplate,
  | "name"
  | "description"
  | "columns"
  | "ignitionValue"
  | "isDefaultTemplate"
  | "tags"
  | "owner"
  | "companies"
  | "displayColumns"
  | "errorCodesMappingName"
  | "internalTariffId"
  | "odometerSource"
>;
